module.exports = __webpack_public_path__ + "img/inventory-management.7848c3ef.svg";